export const FEATURE_FLAGS = {
  SETTINGS: "settings",
  SETTINGS_ACCOUNT: "settings.account",
  SETTINGS_THEME: "settings.theme",
  SETTINGS_TEAM: "settings.team",
  SETTINGS_AI: "settings.ai",
  SETTINGS_CRAWLER: "settings.crawler",
  SETTINGS_TENANT: "settings.tenant",

  DOMAINS: "domains",
  TEAM_MEMBERS: "team_members",
  API_KEYS: "api_keys",
  BILLING: "billing",

  SERVICES: "services",
  SERVICES_BRAND_LINKS: "services.brand_links",
  SERVICES_NICHE_LINKS: "services.niche_links",
  SERVICES_CONCIERGE: "services.concierge",
  SERVICES_LLM_CITATIONS: "services.llm_citations",
  SERVICES_COMMUNITY_MENTIONS: "services.community_mentions",

  SITES: "sites",
  SITES_DASHBOARD: "sites.dashboard",
  SITES_ANALYTICS: "sites.analytics",
  SITES_PAGES: "sites.pages",
  SITES_ENHANCEMENTS: "sites.enhancements",
  SITES_ENHANCEMENTS_INSTALL: "sites.enhancements_install",
  SITES_RECOMMENDATIONS: "sites.recommendations",
  SITES_CUSTOMIZATIONS: "sites.customizations",
  SITES_SCHEMA: "sites.schema",
  SITES_AI_INSTRUCTIONS: "sites.ai_instructions",
  SITES_INTERLINKS: "sites.interlinks",
  SITES_KEYWORDS: "sites.keywords",
  SITES_KEYWORD_IMPORTS: "sites.keyword_imports",
  SITES_GOOGLE_DASHBOARD: "sites.google_dashboard",
  SITES_VISIBILITY_ENGINE: "sites.visibility_stats", // backend identifier unchanged

  // site settings
  SITES_SETTINGS_GENERAL: "sites.settings.general",
  SITES_SETTINGS_PRERENDERING: "sites.settings.prerendering",
  SITES_SETTINGS_CRAWLER: "sites.settings.crawler",
  SITES_SETTINGS_JSON_SCHEMA: "sites.settings.json_schema",
  SITES_SETTINGS_GOOGLE_INTEGRATIONS: "sites.settings.google_integrations",
  SITES_SETTINGS_WHITELIST: "sites.settings.whitelist",
  SITES_SETTINGS_AI: "sites.settings.ai",
  SITES_SETTINGS_JS_SNIPPET: "sites.settings.js_snippet",
  SITES_SETTINGS_WAF: "sites.settings.waf",

  // site links
  SITES_LINKS: "sites.links",
  SITES_LINKS_NICHE: "sites.links.niche",
  SITES_LINKS_OUTREACH: "sites.links.outreach",
  SITES_LINKS_BRAND: "sites.links.brand",

  // site reports
  SITES_REPORTS: "sites.reports",
  SITES_REPORTS_BUILT_LINKS: "sites.reports.built_links",
  SITES_REPORTS_KEYWORD_RANKINGS: "sites.reports.keyword_rankings",
  SITES_REPORTS_SITE_SALES: "sites.reports.site_sales",
  SITES_REPORTS_RECOMMENDATION_EXPORTS: "sites.reports.recommendation_exports",
  SITES_REPORTS_WORK_DONE: "sites.reports.work_done",
  SITES_REPORTS_CLIENT: "sites.reports.client",
};
